import { useState, useEffect } from "react";

const INACTIVITY_TIMEOUT = 10 * 60 * 1000; // 30 minutes in milliseconds

const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!localStorage.getItem("authToken")
  );

  const resetInactivityTimer = () => {
    localStorage.setItem("lastActivity", Date.now().toString());
  };

  const login = (token) => {
    localStorage.setItem("authToken", token);
    resetInactivityTimer();
    setIsAuthenticated(true);
  };

  const logout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("lastActivity");
    setIsAuthenticated(false);
  };

  const checkInactivity = () => {
    const lastActivity = localStorage.getItem("lastActivity");
    if (lastActivity) {
      const timeSinceLastActivity = Date.now() - parseInt(lastActivity);
      if (timeSinceLastActivity > INACTIVITY_TIMEOUT) {
        logout();
      }
    }
  };

  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem("authToken");
      setIsAuthenticated(!!token);
    };

    // Check authentication and inactivity
    checkAuth();
    checkInactivity();

    // Set up activity listeners
    const activityEvents = ["mousedown", "keydown", "scroll", "touchstart"];
    activityEvents.forEach(event => {
      window.addEventListener(event, resetInactivityTimer);
    });

    // Set up inactivity checker interval
    const inactivityInterval = setInterval(checkInactivity, 60000); // Check every minute

    // Set up storage event listener for cross-tab sync
    window.addEventListener("storage", checkAuth);

    return () => {
      activityEvents.forEach(event => {
        window.removeEventListener(event, resetInactivityTimer);
      });
      clearInterval(inactivityInterval);
      window.removeEventListener("storage", checkAuth);
    };
  }, []);

  return { isAuthenticated, login, logout };
};

export default useAuth;